// Note: Subitems are now linked to PDF files in the /pdfs directory.
// The PDF filenames are derived from the subitem names (lowercase, spaces replaced with hyphens).
// For example, "Washington D.C." links to "/pdfs/washington-d.c..pdf"


export const menuData = [
    {
      title: "By Destination",
      items: [
        {
          title: "United States",
          subitems: ["USA", "London", "Canada", "Germany", "Finland", "Europe"]
        },
        {
          title: "North and Central America",
          subitems: ["United Nations", "Switzerland", "Australia", "Japan", "South Korea", "Singapore", "Dubai","Vietnam"]
        },
        // {
        //   title: "South America",
        //   subitems: ["Brazil", "Peru", "Argentina", "Chile"]
        // },
        // {
        //   title: "Europe",
        //   subitems: ["France", "Italy", "Spain", "Germany"]
        // },
        // {
        //   title: "Asia",
        //   subitems: ["Japan", "China", "India", "Thailand"]
        // },
        // {
        //   title: "Africa",
        //   subitems: ["South Africa", "Kenya", "Egypt", "Morocco"]
        // },
        // {
        //   title: "Australia & South Pacific",
        //   subitems: ["Australia", "New Zealand", "Fiji", "Samoa"]
        // }
      ]
    }
  ];
  
  export const navItems = ["Browse Programs"];
  
  